<template lang="pug">
div
  template(v-if="showNewCheckout")
    checkout-new
  template(v-else)
    checkout-old(@dispense="hasDispenseNote = $event" @showUpgradeDialog="showDialog = true; showSnackbar = false")

  .modal
    v-snackbar.mb-2(v-model="showSnackbar" :timeout="-1" bottom color="blue100")
      div.d-flex.align-center(v-if="hasDispenseNote")
        v-icon(size="32" color="neutral700") $yzi-dispense
        div.ml-3
          div.text-xs.neutral700--text.font-semibold You have a dispense note for this patient
          div.text-xs.neutral700--text Switch to new dispensary to view the dispense note.
        v-spacer
        y-button(label="Learn more" color="neutral700" size="xs" button-class="px-3" height="24" @click="showDialog = true; showSnackbar = false")
      div.d-flex.align-center(v-else)
        v-icon(size="32" color="neutral700") $yzi-layout-alt-duotone-04
        div.ml-3
          div.text-xs.neutral700--text.font-semibold New & Improved Dispensary Page
          div.text-xs.neutral700--text Streamlined for speed and clarity.
        v-spacer
        y-button(label="Learn more" color="neutral700" size="xs" button-class="px-3" height="24" @click="showDialog = true; showSnackbar = false")
    y-dialog(v-model="showDialog" scrollable persistent content-class="round-2xl unset-width")
      v-card(color="#ebebeb")
        v-card-title.pt-4.px-4.pb-0
          v-row(no-gutters align="center")
            v-col(cols="12" align="right")
              v-btn(icon @click="showDialog = false" small color="primary")
                v-icon(size="24") mdi-close
        v-card-text.px-6.pb-3
          div.text-3xl.font-semibold.text-center.neutral700--text Upgraded Billings & Dispensary page
          div.text-lg.text-center.neutral700--text.mt-2 Redesigned to meet your needs 
          div.d-flex.justify-center.mt-4
            video(:src="require('@/assets/Video_switch_to_dispensary.mp4')" autoplay muted loop playsinline, :style="`height: ${videoHeight};`")
        v-divider
        v-card-actions.pb-4.pt-3.px-6
          v-spacer
          //- y-button.mr-5(label="Watch video to learn more" color="neutral400" height="44" text-color="neutral700" background-color="var(--v-neutral100)" outlined size="md" @click="watchVideo")
          y-button(label="Switch to new version" color="neutral700" size="md" height="44" dark :loading="isLoading" @click="switchCheckout")

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CheckoutOld from '@/components/clinic/checkout/CheckoutOld.vue'
import CheckoutNew from '@/components/clinic/checkout/CheckoutNew.vue'

export default {
  name: 'CheckoutDetails',
  components: { CheckoutOld, CheckoutNew },
  data() {
    return {
      isLoading: false,
      showSnackbar: false,
      showDialog: false,
      hasDispenseNote: false,
    };
  },
  computed: {
    ...mapState('user', ['member']),
    ...mapState('clinic', ['cmsOsV2Enabled']),
    ...mapGetters({
      registration: 'treatment/getRegistration',
      isHq: 'hq/getIsHq'
    }),
    showNewCheckout () {
      return this.cmsOsV2Enabled || this.member?.extra_data?.new_checkout || false
    },
    videoHeight () {
      let dialogHeight = window.innerHeight * 0.9
      let videoHeight = dialogHeight - 48 - 72 - 105
      return videoHeight + 'px'
    },
  },
  mounted() {
    this.$store.dispatch('clinic/fetchCmsOsV2', this.$axios)
    this.checkCheckoutVersion()
  },
  methods: {
    checkCheckoutVersion () {
      this.$nextTick(() => {
        if (!this.showNewCheckout && !this.cmsOsV2Enabled) {
          this.showSnackbar = true
        }
      })
    },
    switchCheckout() {
      this.isLoading = true
      let params = {
        extra_data: {
          ...this.member.extra_data,
          new_checkout: true
        }
      }
      this.$axios.patch(`/members/${this.member.id}/`, params)
        .then(resp => {
          this.$store.commit('user/setMember', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    watchVideo() {
      window.open('https://www.loom.com/share/e1be857ae9464bd8ad8a21cec1981664?sid=e7a12522-2222-47bd-a0a4-f1f9e0bb5836', '_blank')
    }
  },
  beforeDestroy () {
    this.$store.commit('hq/resetSelectedCompany')
  }
}
</script>

<style lang="scss" scoped>
::v-deep .unset-width {
  width: unset !important;
}
</style>